import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Formik } from "formik";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Layout from "../../components/Layout";
import FormFooter from "../../components/FormFooter";
import FormHeader from "../../components/FormHeader";
import Stepper from "../../components/Stepper";
import FormUnit from "../../components/FormUnit";
import { UNIT_VALIDATION_SCHEMA as validationSchema } from "../../constants/validation";
import { UNIT_INITIAL_VALUES } from "../../constants/initialValues";
import {
  updatePropertyUnit,
  addPropertyUnit,
  getPropertyUnit,
} from "../../services/units";

function UnitForm(props) {
  const history = useHistory();
  const { id, unitid } = props.match.params;
  const [initialValues, setInitialValues] = useState(UNIT_INITIAL_VALUES);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (unitid && unitid !== "add") {
      setIsLoading(true);
      getPropertyUnit(id, unitid).then((data) => {
        setInitialValues(data);
        setIsLoading(false);
      });
    } else if (id) {
      setInitialValues({
        ...UNIT_INITIAL_VALUES,
        propertyId: id,
      });
    }
  }, [id, unitid]);

  const onSubmit = (values) => {
    setIsLoading(true);
    const payload = {
      ...values,
      propertyId: id,
    };
    if (unitid && unitid !== "add") {
      updatePropertyUnit(id, unitid, payload).then((data) => {
        history.push(`/add-property/${id}/unit/${data.id}/lease`);
      });
    } else {
      addPropertyUnit(id, payload).then((data) => {
        history.push(`/add-property/${id}/unit/${data.id}/lease`);
      });
    }
  };

  if (id && !initialValues) {
    return null;
  }

  return (
    <Layout isLoading={isLoading}>
      <Stepper id={id} currentStepIndex={2} />
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {({ handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <Box sx={{ gridArea: "main" }}>
              <Paper sx={{ marginBottom: "2rem", padding: "2rem" }}>
                <FormHeader title="Unit" description="" />
                <Grid container spacing={1}>
                  <FormUnit />
                </Grid>
              </Paper>
              <FormFooter />
            </Box>
          </form>
        )}
      </Formik>
    </Layout>
  );
}

export default UnitForm;
